import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HeroHeadersBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { HeroBlock4 as Block } from "./HeroBlock4";
import { defaultData } from "./HeroBlock4DefaultData";
import { defaultStyles } from "./defaultStyles";
import imagePreview from "./homepage_block_4_preview.png";

export const HeroBlock4: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Hero Block 4",
    nameI18n:
      "settings.emails.visual_builder.block_type.hero_block.hero_block_4",
    version: 1,
    category: [HeroHeadersBlock],
    props: {
      leftContent: {
        name: "Left Content",
        nameI18n: "builder_ui.prop_type.left_content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      rightContent: {
        name: "Right Content",
        nameI18n: "builder_ui.prop_type.right_content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      buttons: {
        name: "Buttons",
        nameI18n: "builder_ui.prop_type.buttons",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        type: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            category: [DesignProp, GeneralProp],
            defaultValue: defaultStyles.backgroundColor,
            type: "color-without-alpha",
            nameI18n:
              "settings.emails.visual_builder.prop_type.styles.background_color",
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            category: [DesignProp, PaddingsProp],
            defaultValue: defaultStyles.padding,
          },
          margin: {
            ...margin,
            category: [DesignProp, MarginsProp],
            defaultValue: defaultStyles.margin,
          },
        },
      },
    },
  },
};
